/**
 * makeCancelablePromise
 *
 * Make a (wrapped) canceable Promise
 *
 */
export type CancelablePromise = {
  promise: Promise<any>;
  cancel: () => void;
};

export function makeCancelablePromise(promise: Promise<any>): CancelablePromise {
  let hasBeenCanceled = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise
      .then(val => (hasBeenCanceled ? reject({ isCanceled: true }) : resolve(val)))
      .catch(error => (hasBeenCanceled ? reject({ isCanceled: true }) : reject(error)));
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasBeenCanceled = true;
    },
  };
}
